export default __webpack_public_path__ + "static/media/teams-header.58949ea4.jpg";